import React, { useEffect, useState } from 'react';
import moment from 'moment';
import InputField from '../UI/Input/InputField';
import ButtonField from '../UI/Button/ButtonField';
import {Row, Col } from "react-bootstrap";
import Card from "../Card/Card";
import { FetchAPI } from '../../api/fetch';
import './FilterBox.css';
import { isEmpty } from 'components/Login/validator';
import BeatLoader from "react-spinners/BeatLoader";
import useValidator from 'hooks/useValidator';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { PostAPI } from "api/post";
const cookies = new Cookies();

const FilterBox = ( props ) => {
    const {setHasError} = props;
    const { t, i18n } = useTranslation();
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
    const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
    const formElementsArray = [];
    const [validator, showValidationMessage] = useValidator();
    const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
    let [FilterformValues, setFilterformValues] = useState(props.formValue);
    let [loadSForm, setloadSForm] = useState(true);
    let [selectedFile, setSelectedFile] = useState(null); 
    let [fromDate, setFromDate] = useState();
    let [toDate, setToDate] = useState();
    const vguardReports = ["Inventory","Production","Aging","Bin Location","QC"]
    let getdrpdwnresponse;
    let conditionTextStyles = {
        fontSize:'14px',
        fontWeight:"500",
        color:"#ff3547",
        marxgin:'0',
        padding:'15px 20px'
    }
    let commonParams = {
        customer_id:cookies.get('customer_id'),
        user_id:cookies.get('user_id'),
        userLocation_id:cookies.get('userLocation_id'),
        userRole_name:cookies.get('userRole_name'),
        language:language
    }
    for (let key in FilterformValues){
        formElementsArray.push({
            id: key,
            config: FilterformValues[key]
        });
    }

    const getFormattedDates = (data) => {
        try{
        const filteredCopiedObj = JSON.parse(JSON.stringify(data));
        if (filteredCopiedObj.from_date?.value) {
            filteredCopiedObj.from_date.value = moment(filteredCopiedObj.from_date.value).format('YYYY-MM-DD')
        }
        if (filteredCopiedObj.to_date?.value) {
            filteredCopiedObj.to_date.value = moment(filteredCopiedObj.to_date.value).format('YYYY-MM-DD')
        }
        return filteredCopiedObj;
        } catch (e) {
            setHasError({
             error: true,
                message: e
            })
        }
    }
    
    async function filteredExport(e) {
        try{
        const getUpdatedValues = getFormattedDates(FilterformValues)
        if (props.title !== 'Log' && props.title !== "Fifo Violation") {
            if (validator.allValid()) {
                props.setformValues(FilterformValues)
                props.filteredExport(getUpdatedValues);
            } else {
                showValidationMessage(true);
            }
        }
        else if (props.title === 'Log') {
            formElementsArray.forEach(function(formElement, indexIdx){
                if(formElement.id === "to_date" || formElement.id === "from_date" || formElement.id === "product_id"){

                    formElement.config.validate.required = false
                }
            // if(FilterformValues['product_id'].value !== null){
            //     if(formElement.id === "to_date" || formElement.id === "from_date"){
            //         formElement.config.validate.required = false
            //     }
            // }
            // else {
            //     if(formElement.id === "product_id"){
            //         formElement.config.validate.required = false
            //     }
            // }
            })
            if(validator.allValid()){

                props.setformValues(FilterformValues)
                 props.filteredExport(getUpdatedValues);
            }
            else{
                showValidationMessage(true);
            }
        }
        if (props.title === 'Fifo Violation') {
            formElementsArray.forEach(function (formElement, indexIdx) {
                if (formElement.id === "to_date" || formElement.id === "from_date" || formElement.id === "product_id" || formElement.id === "location_id") {
                    formElement.config.validate.required = false
                }
            })
            if(validator.allValid()){
                props.filteredExport(getUpdatedValues);
               props.setformValues(FilterformValues)
           }
           else{
               showValidationMessage(true);
           }
        }
        // if (props.title !== 'Log' && props.title !== "Fifo Violation") {
        //     if (validator.allValid()) {
        //         props.setformValues(FilterformValues)
        //         props.filteredExport(FilterformValues);
        //     } else {
        //         showValidationMessage(true);
        //     }
        // }
	} catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
}
    async function filteredExport1(e) {
        try{
        const getUpdatedValues = getFormattedDates(FilterformValues)
        if (cookies.get('customer_id') === '15' &&  props.title === 'Production') {
            if(validator.allValid()){
                props.setformValues(FilterformValues)
                props.filteredExport1(getUpdatedValues);
           }
           else{
               showValidationMessage(true);
           }
        }else{
            props.setformValues(FilterformValues)
            props.filteredExport1(getUpdatedValues);
        }
    } catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
}
    // async function filteredExport(e) {
    //     const searchFormData = {};
    //     const getURL= props.exportApiEndPoint+'?customer_id='+cookies.get('customer_id') 
    //     + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email');
    //    // const getURL = 'https://c1m36osb45.execute-api.ap-south-1.amazonaws.com/dev/getproductionReportexcel';
    //     let newgetURL;
    //     for (let formElementIdentifier in FilterformValues) {
    //       searchFormData[formElementIdentifier] = FilterformValues[formElementIdentifier].value;
    //     }
    //     console.log("@@123primary check",searchFormData)
    //     const paramString = new URLSearchParams(searchFormData);
    //     console.log("@@123456primary check",paramString)
    //     console.log("@@1236primary check",paramString.toString())
    //     newgetURL = (`${getURL}&${paramString.toString()}`);
    //     const getresponse = await FetchAPI(newgetURL);
    //     if(getresponse.status == 200){
    //         swal('Your request is under process',
    //         'Shortly, you will receive an email with downlodable link','success')
    //     //window.location.href = "https://tertiary-label-printing.s3.amazonaws.com/OrientReports/2020-10-27/ProductionReport.xlsx";
    //     }
    //     else{
    //       swal('Something went wrong','Please download again','error')
    //     }
    //   }
      const clearFunction = (event) => {
        try{
        // if(props.title == 'Inventory' || props.title == 'Product Locations') {
        //     const updateOrderForm = {
        //         ...FilterformValues
        //     }
        //     if(updateOrderForm['location_type']){
        //     let getURL = updateOrderForm['location_type'].update.endPoint+'?location_type=0';
        //     const commanParamVal = new URLSearchParams(commonParams);
        //     let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
        //     updateDropDwon(newgetURL, updateOrderForm)
        // }
        // }
        props.clearClick();
        // props.setValidation(false)
      } catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
    }
    const checkValidationFirst = (event) => {
        try{
        if(Object.hasOwn(props, 'setFilterToExport'))
         props.setFilterToExport(prevState => {
            return {
              ...prevState,
              change:false
            }
          })
        let arr = Object.values(FilterformValues);
        let valueNull = arr.some((el) => el.value !== null)
        if (validator.allValid()) {
            // if(props.title=='IOT Status/Adjustment' && !selectedFile)
            // swal("File Mandatory!", "Uploading file is mandatory", "error");
            // else
            props.setformValues(FilterformValues)
            const getUpdatedValues = getFormattedDates(FilterformValues)
            props.searchClick(getUpdatedValues);
        }
        else{
        showValidationMessage(true);
        }
    } catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
}
    let searchFormData = {}
    for (let inputIdentifier in FilterformValues) {
        searchFormData[inputIdentifier] = FilterformValues[inputIdentifier].value;
    } 
    

    useEffect(() => {
        try{
        if (props.filterToExport?.change) {
                const getUpdatedValues = getFormattedDates(FilterformValues)
                if (validator.allValid()) {
                    props.setformValues(getUpdatedValues)
                } else {
                    showValidationMessage(true);
                }
            }
        }catch (e) {
            setHasError({
             error: true,
                message: e
            })
        }
    }, [FilterformValues, props.filterToExport?.change])
    
    async function inputChangedHandler(event,inputIdentifier) {
        try{
        const updateOrderForm = {
          ...FilterformValues
        }
        const updateElemetForm = {
          ...updateOrderForm[inputIdentifier]
        };

        if(typeof event === "string"){
            updateElemetForm.value = event === "" ? event : moment(event);
            updateOrderForm[inputIdentifier] = updateElemetForm;
            const getUpdatedValues = getFormattedDates(updateOrderForm)
            props.filteredExport2(getUpdatedValues);
            setFilterformValues(updateOrderForm);
            return;
        }else if(inputIdentifier === "time_range"){
            updateElemetForm.value = event
            updateOrderForm[inputIdentifier] = updateElemetForm;
        }
        else if(updateOrderForm[inputIdentifier].elementType == 'multiselect') {
            if(Array.isArray(event) && event.length !== 0)
                updateElemetForm.value = event;
            else
                updateElemetForm.value = null;
        }
        else if(updateOrderForm[inputIdentifier].elementType == 'selectshowsearch') {
            updateElemetForm.value = event;
            if (event) {
                if (updateOrderForm[inputIdentifier].update.required === true) {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint + '?' + inputIdentifier + '=' + event.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                }
            }
    }
        else if(updateOrderForm[inputIdentifier].elementType == 'select'){ 
            if(event.target.value !== `${t('please_select')}`){
            updateElemetForm.value = event.target.value;
            }else{
                updateElemetForm.value = null;
            }
        }
        else if(event.target.type === 'checkbox') {
            updateElemetForm.value = event.target.checked;
        }
        else if((updateOrderForm[inputIdentifier].elementType === 'file')) {
           
            if(event.target.files[0])
            setSelectedFile(event.target.files[0])
            let ext;
            if(event.target.files[0]) {
                ext = event.target.files[0].name.split(".")[1];
            }
            // if(ext != 'xlsx' || ext != 'csv')
            // swal("Wrong Extension File", "Only .xlsx, .csv file extensions are allowed", "error");
            // else {
                let formData;
                const data = new FormData() 
                data.append('file', event.target.files[0])
                data.append('formValues',searchFormData)
                const getURL='https://c1m36osb45.execute-api.ap-south-1.amazonaws.com/dev/iot-status/import-iot';
                let responseData = await PostAPI(getURL, data);
                    if(responseData.status == 200)
                        swal('sucess','success')
                    else
                      swal('Something went wrong','Please try again','error')

        }
        else {
            if(event.target.value && event.target.value !== 'Select Line')
                updateElemetForm.value = event.target.value;
            else
                updateElemetForm.value = null;
        }
        updateOrderForm[inputIdentifier] = updateElemetForm;
        const getUpdatedValues = getFormattedDates(updateOrderForm)
        props.filteredExport2(getUpdatedValues);
        setFilterformValues(updateOrderForm);
     //  props.setformValues(updateOrderForm);
        if(updateOrderForm[inputIdentifier].elementType == 'select' ){
            if(updateOrderForm[inputIdentifier].update.required === true){
                let keyName = event.target.id;
                if(event.target.value)
                {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.target.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                }
            }
        }
        if(updateOrderForm[inputIdentifier].elementType == 'multiselect') {
            if(updateOrderForm[inputIdentifier].update.required === true){
                if((Array.isArray(updateOrderForm[inputIdentifier].value) && 
                updateOrderForm[inputIdentifier].value.length !== 0) || (props.title == 'Inventory' && inputIdentifier == 'product'))
                {    
                  let arrayConvert = [];
                  if((Array.isArray(updateOrderForm[inputIdentifier].value))) {
                  updateOrderForm[inputIdentifier].value.map(function(fValue, indexId){
                    arrayConvert[indexId] = fValue.value;
                  })
                } else 
                arrayConvert[0]=0;
                  if(props.title == 'Inventory' && inputIdentifier == 'product')
                    {
                        let URL = updateOrderForm[inputIdentifier].update.endPoint;
                        let body = {product:arrayConvert,...commonParams}
                       setloadSForm(true);
                         const getdrpdwnresponseJson = await PostAPI(URL,body);
                       //  const getdrpdwnresponseJson = await getdrpdwnresponse.json();
                    //      const updateForm = {
                    //        ...updateOrderForm
                    //    }
                       const dropVal = {
                           ...getdrpdwnresponseJson.data.data
                       }
                       let obj;
                       obj = Object.keys(getdrpdwnresponseJson.data.data).forEach((el) => {
                           if( Object.keys(el, updateOrderForm)){
                                       updateOrderForm['storage_location'].elementConfig.options = dropVal['storage_location'];
                                    //    updateOrderForm['storage_location'].elementConfig.options.splice(0, 0, ...initialValue)
                           }
                       })
                       setFilterformValues(updateOrderForm);
                     // props.setformValues(updateForm);
                       setloadSForm(false);
                        
                    }else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+arrayConvert;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                    }
                }else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'=0';
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                   
                }
            }
        }
    } catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
}

    async function updateDropDwon(URL, FormVal){
        try{
        setloadSForm(true);
        props.setSelectChildValue();
          const getdrpdwnresponse = await FetchAPI(URL);
          const getdrpdwnresponseJson = await getdrpdwnresponse.json();
          const updateForm = {
            ...FormVal
        }
        const dropVal = {
            ...getdrpdwnresponseJson.data
        }
        let obj;
        obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
            if( Object.keys(el, updateForm)){
                updateForm[el].value=null;
                // if(!isEmpty(dropVal[el])){
                    if(updateForm[el].elementType == 'select'){
                        updateForm[el].elementConfig.options = dropVal[el];
                        updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                    }
                    else if(updateForm[el].elementType == 'multiselect') {
                        updateForm[el].elementConfig.options = dropVal[el];
                    }   
                // }
            }
        })
        setFilterformValues(updateForm);
      // props.setformValues(updateForm);
        setloadSForm(false);
      } catch (e) {
        setHasError({
            error: true,
            message: e
        })
    }
    }

    useEffect(() => {
        try{
        (async () => {
            if(props.dropDownApi === 'not found')
                setloadSForm(false);
            else
            {
                setloadSForm(true);
                let getdrpdwnresponseJson
                if(props?.dropdownMethod === "POST"){
                    const formData = new FormData();
                    formData.append("type","fetch_all_po_loc_ean");
                    const response = await PostAPI(props.dropDownApi,formData);
                    response.data.data.newPO = response.data.data.all_po_number
                    response.data.data.oldPO = response.data.data.all_po_number
                    response.data.data.oldLocation = response.data.data.all_locations
                    response.data.data.newLocation = response.data.data.all_locations
                    response.data.data.oldEAN = response.data.data.all_products
                    response.data.data.newEAN = response.data.data.all_products
                    delete response.data.data.status;
                    delete response.data.data.message;
                    getdrpdwnresponseJson = response.data;
                }else{
                    getdrpdwnresponse = await FetchAPI(props.dropDownApi);
                    getdrpdwnresponseJson = await getdrpdwnresponse.json();
                }
                if(props.title === "Delivery" && cookies.get("customer_id") == 17){
                    if(cookies.get('userRole_name') === "Super Admin"){
                        getdrpdwnresponseJson.data["src_location"] = getdrpdwnresponseJson.data.from_location_id
                    }else{
                        let sourceLocation = [];
                        let destinationLocation = [];
                        getdrpdwnresponseJson.data.from_location_id.map(location => {
                            if(location.value == cookies.get("userLocation_id")){
                                sourceLocation.push(location)
                            }else{
                                destinationLocation.push(location)
                            }
                        
                        })
                        getdrpdwnresponseJson.data["src_location"] = sourceLocation;
                        getdrpdwnresponseJson.data.from_location_id = destinationLocation;
                    }
                }

                const updateForm = {
                    ...FilterformValues
                }
                const dropVal = {
                    ...getdrpdwnresponseJson.data
                }
                if(cookies.get("customer_id") === "13" && props.title === "Scrap"){
                    if(getdrpdwnresponseJson?.data?.locations?.length === 0){
                        delete updateForm['locations']
                    }
                }
                
                // delete dropVal['allowedAddLocationTypes'];
                {props.title === 'Revert Assigned' && delete getdrpdwnresponseJson.data['po_number']}
                let obj;
                obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
                    if( Object.keys(el, updateForm)){
                        if(!isEmpty(dropVal[el])){
                            if(updateForm[el]?.elementType == 'select'){
                            if(el === 'lot_number'){
                                const modifiedOptions = dropVal[el].reduce((lot_no, value) => {
                                    lot_no.push({ value: value[el], displayValue: value[el] });
                                    return lot_no;
                                  }, []);
                                updateForm[el].elementConfig.options = modifiedOptions;
                                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                            }else if(el !== 'lot_number'){
                                updateForm[el].elementConfig.options = dropVal[el];
                                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                            }
                            }
                            else if(updateForm[el]?.elementType == 'multiselect') {
                                updateForm[el].elementConfig.options = dropVal[el];
                            }else if(updateForm[el]?.elementType == 'selectshowsearch'){
                                updateForm[el].elementConfig.options = dropVal[el];
                            }   
                        }
                        else
                        {
                            if(updateForm[el]?.elementType == 'select' )
                            updateForm[el].elementConfig.options = initialValue;
                            if(updateForm[el]?.elementType == 'multiselect' )
                            updateForm[el].elementConfig.options = null;
                        //updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                        }
                    }
                    setFilterformValues(updateForm);
                })
                setloadSForm(false);
            }
        })()
    } catch (e) {
        setHasError({
         error: true,
            message: e
        })
    }
    }, [])

    let rcount = 1;
    return (
        <div key="ModalMDIV">
            { (loadSForm === true|| props.isFilterLoader === true) &&
            <div className="filter-loader">
               <div className='spanLoading'>
                    <span>Loading...</span>
                </div>
                <BeatLoader />
            </div>}
            <Card
            key="CardFilter" 
            // condition = {(props.filterCondition === true) ? <>{`${t('filtered_Condition')}`}<span> {`${t('15_days')}`} </span></> : ""}
            plain
            filter={true}
            title={props.title}
            content={
                    <form key="ModalForm">
                    <Row md={12} key="ROW1">
                        <div className="form-grid">
                            {/* <MDBRow key="ModalMDBRow"> */}
                            {formElementsArray.map(function (formElement, indexIdx) {
                                return (
                                    <div className="grid-item" key={formElement.id}>
                                        <InputField
                                            key={formElement.id}
                                            elementType={formElement.config.elementType}
                                            elementConfig={formElement.config.elementConfig}
                                            value={(formElement.config.value == null) ? '' : formElement.config.value}
                                            labelName={formElement.config.label}
                                            id={formElement.config.id}
                                            isValidate={formElement.config.validate}
                                            selectChildValue={props.selectChildValue}
                                            changed={(event) => inputChangedHandler(event, formElement.id)}
                                            validater={validator}
                                            // validate = {props.validation}
                                            selectedFile={selectedFile}
                                            fromDate={fromDate}
                                            setFromDate={setFromDate}
                                            toDate={toDate}
                                            setToDate={setToDate}
                                            title={props.title}
                                        // loc ={(FilterformValues.location) ? (FilterformValues.location.value) :''
                                        />
                                    </div>
                                )
                            })}
                            <Col md="4" key="ModalDIV">
                                {props.title == 'Lookup' ? 
                                <div className='button-container'>
                                    <ButtonField color="danger" key="ModalCLRBTN" submit={(event) => clearFunction(event)} BName={t("clear")} />
                                    <ButtonField color="info" key="ModalSRCHBTN" submit={(event) => checkValidationFirst()} BName={t("search")} />
                                </div> : ''}
                            </Col>
                        </div>
                    </Row>
                    <Row key="ModalMDBROW1">
                        <Col md="6" className="mb-6" key="ModalMDBCOL2"></Col>
                        <Col md="12" className="mb-6" key="ModalMDBCOL3">
                            {(props?.addSapProduct !== undefined && props?.addSapProduct) ? (
                                <div className='button-container'>
                                    <ButtonField color="danger" key="ModalCLRBTN" submit={(event) => clearFunction(event)} BName={t("clear")} />
                                    <ButtonField color="info" disabled={loadSForm} submit={() => props?.handleSubmitClick(validator, showValidationMessage, FilterformValues, setloadSForm)} BName={"Submit"} />
                                </div>
                            )
                                : (
                                    <>
                                        {props?.filterCondition ?
                                            <span style={conditionTextStyles}>{`${t('filtered_Condition')}`}</span> : ""}
                                        <div className='button-container' key="ModalDIV">
                                            {props.title !== 'Stock Out' && props.title !== 'Lookup' ?
                                                <>
                                                    <ButtonField color="danger" key="ModalCLRBTN" submit={(event) => clearFunction(event)} BName={t("close")} />
                                                    {props.title === 'Log' ? " " : <ButtonField color="info" key="ModalSRCHBTN" submit={(event) => checkValidationFirst()} BName={t("search")} />}
                                                </> :
                                                ''}
                                            {(props.exportFilterButton === true && props?.exportFilterButtonName) ? <ButtonField color="info" submit={(e) => filteredExport(e)} BName={props.exportFilterButtonName} /> :
                                                (props.exportFilterButton === true) ? <ButtonField color="info" submit={(e) => filteredExport(e)} BName={t("filter_export")} /> : ''}
                                            {(props.exportFilterButton1 === true) ? <ButtonField color="info" submit={(e) => filteredExport1(e)} BName={props.exportFilterButtonName1} /> : ''}
                                        </div>
                                    </>
                        )}  
                        { (cookies.get("customer_id") === "5" && vguardReports.includes(props.title)) && <div className='three-months-restriction' >** Displays data for a maximum date range of 3 months.</div>}  
                        </Col>
                    </Row>
                    </form>
                }
                />
        </div>
    );
}

export default FilterBox;